import React, { useState } from 'react';

const ResourcesStacked = ({ title, iconSrc, link, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  const barStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    padding: '15px 20px',
    marginBottom: '10px',
    
    backgroundColor: '#D5B3E7',
    border: isHovered ? '1px solid #6E4884' : '1px solid #d3b4ec',
    borderRadius: '15px',
    boxShadow: isHovered ? '0px 4px 12px rgba(110, 72, 132, 0.4)' : '0px 2px 8px rgba(0, 0, 0, 0.2)',
    
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
    fontFamily: 'Poppins',
  };

  const iconContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '60px',
    height: '60px',
    flexShrink: 0,
  };

  const iconStyle = {
    width: '50px',
    height: '50px',
    objectFit: 'contain',
  };

  const textContainerStyle = {
    flex: 1,
  };

  const titleStyle = {
    margin: 0,
    fontSize: '1.2em',
    fontWeight: 'bold',
    color: '#6E4884',
    textDecoration: isHovered ? 'underline' : 'none',
  };

  return (
    <a 
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: 'none' }}
      onClick={onClick}
    >
      <div 
        style={barStyle}
        onMouseEnter={() => setIsHovered(true)} 
        onMouseLeave={() => setIsHovered(false)}
      >
        <div style={iconContainerStyle}>
          <img 
            src={process.env.PUBLIC_URL + iconSrc} 
            alt="Resource icon" 
            style={iconStyle}
          />
        </div>
        
        <div style={textContainerStyle}>
          <h3 style={titleStyle}>{title}</h3>
        </div>
      </div>
    </a>
  );
};

export default ResourcesStacked;